import React from "react";
import { Link } from "gatsby";
import * as c from "./TextLink.module.scss";
import classNames from "classnames";
import IconArrowRight from "@components/icons/iconArrowRight";
import { Text } from "@components/shared";

/**
 * This is a simple component that wraps a Gatsby Link component and applies some styling.
 * @param {string} props.to - The URL to navigate to when the link is clicked.
 * @param {string} props.children - The text to be displayed inside the link.
 * @param {string} [props.className] - Additional CSS class name to be applied to the link.
 * @param {string} [props.textClassName] - Additional CSS class name to be applied to the text.
 * @param {string} [props.icon] - The icon value, which should be either "arrow" or undefined/null (intended to be extended later).
 * @param {string} [props.iconClassName] - Additional CSS class name to be applied to the icon.
 * @returns {ReactNode} The rendered TextLink component.
 */
const TextLink = ({ to, children, className, textClassName, icon, iconClassName }) => {
  const Icon = React.useMemo(() => {
    switch (icon) {
      case "arrow":
        return <IconArrowRight className={classNames(c.icon, c.arrowIcon, iconClassName)} version="v3" />;
      default:
        if (icon) {
          console.warn(`Invalid icon value: ${icon}`);
        }
        return null;
    }
  }, [icon, iconClassName]);

  return (
    <Link to={to} className={classNames(c.link, className, icon === "play" && c.reverse)}>
      <Text variant="eyebrow" className={classNames(c.linkText, textClassName)}>
        {children}
      </Text>
      {Icon}
    </Link>
  );
};

export default TextLink;
